import Utils from './utils';

class Slider {
  constructor() {
    this.fullScreenActiveSlide = false;
    this.slider = null;
    this.sliderWrapper = null;
    this.lastWidth = null;
  }

  init() {
    this.thumbnailHandlers();
    this.largerImageOption();
    this.closeSliderHandler();
    this.loadMoreHandler();
    this.showTags();
  }

  /**
   * Initiate swiper slider as a pop up initiated by a click event
   *
   * Two types of slider - Books and Gallery
   * @param {e} e
   * @returns
   * @memberof Slider
   */
  sliderInit(e) {
    let { target } = e;

    // Make sure the clicked element is
    const _this = this;
    if (!target.classList.contains('js-slider-init')) {
      target = Utils.getClosest(target, '.js-slider-init');
    }

    const sliderWrapper = Utils.getClosest(target, '.js-slider-wrapper');

    const slider = sliderWrapper.querySelector('.swiper-container');

    // Make sure slider is present
    if (!slider) return;

    const sliderType = slider.classList.contains('c-slider--books')
      ? 'books'
      : 'gallery';

    let index =
      sliderType === 'books'
        ? 0
        : Array.from(target.parentElement.children).indexOf(target);

    // If in prints slider then get index of a parent of a clicked item
    if (sliderWrapper.classList.contains('c-prints')) {
      const list = Array.from(
        sliderWrapper.querySelectorAll('.js-slider-item')
      );
      const currentTarget = target.parentElement.parentElement;
      index = list.indexOf(currentTarget);

      console.log('index', index, list, currentTarget);
    }

    slider.classList.add('active');

    let mySwiper;

    // Initiate Books slider
    if (sliderType === 'books') {
      mySwiper = new Swiper(slider, {
        speed: 400,
        initialSlide: index,
        preloadImages: false,
        loadingClass: 'swiper-lazy-loading',
        direction: 'horizontal',
        slidesPerView: 2,
        slidesPerGroup: 2,
        keyboard: {
          enabled: true
        },
        lazy: {
          loadPrevNext: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          // when window width is <= 641px
          641: {
            slidesPerView: 1,
            slidesPerGroup: 1
          }
        },
        on: {
          lazyImageReady(e) {
            const element = e.el ? e.el : e;
            // Utils.fadeIn(element, 'flex');
            element.classList.add('slide-loaded');
            slider.classList.add('loaded');
          },
          slideChange() {
            // console.log('slide change firing', this);
            const readableIndex = this.snapIndex + 1;
            _this.stopAllAudio();
            _this.updateIndex(readableIndex);
          },

          beforeDestroy() {
            slider.classList.remove('active');
            _this.stopAllAudio();
            document.body.classList.remove('slider-active');
          },
          resize() {
            _this.booksResize();
          }
        }
      });
    } else {
      // Initiate Gallery slider
      mySwiper = new Swiper(slider, {
        speed: 400,
        initialSlide: index,
        preloadImages: false,
        loadingClass: 'swiper-lazy-loading',
        direction: 'vertical',
        keyboard: {
          enabled: true
        },
        lazy: {
          loadPrevNext: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          lazyImageReady(e) {
            const element = e.el ? e.el : e;
            // Utils.fadeIn(element, 'flex');
            element.classList.add('slide-loaded');
            slider.classList.add('loaded');
          },
          slideChange() {
            // console.log('slide change firing', this);
            const readableIndex = this.snapIndex + 1;
            _this.stopAllAudio();
            _this.updateIndex(readableIndex);
          },

          beforeDestroy() {
            slider.classList.remove('active');
            _this.stopAllAudio();
            document.body.classList.remove('slider-active');
          }
        }
      });
    }

    // Store slider on class
    this.slider = mySwiper;
    this.sliderWrapper = sliderWrapper;

    // Set scroll prevention on body
    document.body.style.overflow = 'hidden';

    // Get initial index
    _this.getIndex(
      index + 1,
      this.slider.params.slidesPerView,
      this.slider.slides.length
    );
  }

  closeSliderHandler() {
    Array.from(
      document.getElementsByClassName('js-close-slider'),
      closeButton =>
        closeButton.addEventListener('click', this.sliderClose.bind(this))
    );
  }

  sliderClose(e) {
    // If in slider view then close. If larger image view then revert to normal image
    if (
      this.fullScreenActiveSlide &&
      this.fullScreenActiveSlide.classList.contains('full-screen-active')
    ) {
      this.closeLargerImage(e);
      return;
    }
    this.slider.destroy();

    // Set scroll prevention on body
    document.body.style.overflow = '';
  }

  thumbnailHandlers() {
    // For archives the thumbnails can be ajaxed in
    if (document.querySelector('.js-masonry-container')) {
      document
        .querySelector('.js-masonry-container')
        .addEventListener('click', e => {
          if (e.target.classList.contains('js-slider-init')) {
            this.sliderInit(e);
          } else if (e.target.parentNode.classList.contains('js-slider-init')) {
            this.sliderInit(e);
          }
        });
    } else {
      const sliderInitTrigger = document.getElementsByClassName(
        'js-slider-init'
      );

      Array.from(sliderInitTrigger, trigger =>
        trigger.addEventListener('click', this.sliderInit.bind(this))
      );
    }
  }

  largerImageListener(e) {
    // console.log('larger image');

    // TODO: listen to escape to close full screen
    if (e.keyCode === 27) this.closeLargerImage(e);
  }

  stopAllAudio() {
    // TODO: make this only stop audios in slider
    // const audios = Array.from(document.getElementsByTagName('audio'));
    // audios.map(audio => {
    //   audio.parentNode.classList.remove('playing');
    //   audio.pause();
    // });
    // document.querySelectorAll('audio').forEach(button => {
    //   // Now do something with my button
    //   console.log('button exists', button);
    // });
  }

  getIndex(currentIndex, slidesPerView, totalSlides) {
    const totalIndex = Math.floor(totalSlides / slidesPerView);

    if (currentIndex) this.updateIndex(currentIndex);
    this.updateTotalIndex(totalIndex);
  }

  updateTotalIndex(totalIndex) {
    if (!this.slider) return false;

    const sliderTotalIndex = this.sliderWrapper.querySelector(
      '.js-total-slide-index'
    );

    if (totalIndex && sliderTotalIndex) {
      sliderTotalIndex.innerText = totalIndex;
    }
  }

  updateIndex(index) {
    if (!this.slider) return false;
    const sliderIndex = this.sliderWrapper.querySelector(
      '.js-current-slide-index'
    );

    if (index && sliderIndex) {
      sliderIndex.innerText = index;
    }
  }

  booksResize() {
    // Only fires on books, which changes from a 1 slide to 2 slide slider. Need to make sure index is also updated
    const windowWidth = window.innerWidth;
    const { lastWidth } = this;

    if (lastWidth < 641 && windowWidth > 641) {
      // To two slides per view
      const readableIndex = Math.round((this.slider.realIndex + 1) / 2);
      this.getIndex(readableIndex, 2, this.slider.slides.length);
    } else if (lastWidth > 641 && windowWidth < 641) {
      // To one slide per view
      const readableIndex = this.slider.realIndex + 1;
      this.getIndex(readableIndex, 1, this.slider.slides.length);
    }
    this.lastWidth = windowWidth;
  }

  /**
   * Assign click handler to larger image button
   * On click add lazy load class and trigger swiper to load the image
   *
   * @param {any} e
   * @memberof Slider
   */
  largerImageOption() {
    // Larger image button
    const largerImageButton = document.getElementsByClassName(
      'js-larger-image-button'
    );
    Array.from(largerImageButton, thumbnail =>
      thumbnail.addEventListener('click', this.showLargerImage.bind(this))
    );

    // Close larger image
    const closeLargerImage = document.getElementsByClassName(
      'js-close-larger-image'
    );
    Array.from(closeLargerImage, close =>
      close.addEventListener('click', this.closeLargerImage.bind(this))
    );
  }

  showLargerImage(e) {
    const currentSlide = Utils.getClosest(e.target, '.js-single-slide');
    const largerImage = currentSlide.querySelector('.js-larger-image');
    const currentSlider = Utils.getClosest(e.target, '.swiper-container');

    this.fullScreenActiveSlide = currentSlide;

    // Add full screen active class
    // TODO: turn this into a class addition triggerd from a slider method when image is loaded
    currentSlide.classList.add('full-screen-active');
    currentSlider.classList.add('no-navigation');

    // Add event listener for escape button
    // document.addEventListener('keydown', this.largerImageListener.bind(this));

    // Stop slider behaviour
    this.slider.detachEvents();

    // If not loaded then lazy load larger image
    if (!largerImage.classList.contains('swiper-lazy')) {
      largerImage.classList.add('swiper-lazy');
      this.slider.lazy.load();
    }
  }

  closeLargerImage(e) {
    const currentSlide = this.fullScreenActiveSlide;
    const currentSlider = Utils.getClosest(e.target, '.swiper-container');

    // Add full screen active class
    currentSlide.classList.remove('full-screen-active');
    currentSlider.classList.remove('no-navigation');
    this.slider.attachEvents();
  }

  loadMoreHandler() {
    if (document.getElementById('js-load-more')) {
      const loadMore = document.getElementById('js-load-more');
      loadMore.addEventListener('click', this.loadMoreSlides.bind(this));
    }
  }

  loadMoreSlides() {
    // Get max amount of images to load. Set in the DOM from CMS
    const imageMaxLoad = document
      .getElementById('js-masonry')
      .getAttribute('data-gallery');

    // galleryImageAjax is a variable set in the archive twig template. A comma separated string of image ids
    const galleryImageAjaxArray = galleryImageAjax.split(',');
    const imagesToLoad = galleryImageAjaxArray.slice(0, imageMaxLoad);

    const url = `${main_js.ajaxurl}?action=load_more_slides`;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = () => {
      if (xhr.status === 200) {
        // Add ajaxed slides into slider
        const slider = document.getElementById('js-slider-ajax');
        slider.insertAdjacentHTML('beforeend', xhr.response);

        // Update slider max amount
        const newSliderLength = slider.querySelectorAll('.swiper-slide').length;
        Array.from(
          document.getElementsByClassName('c-slider__total-slides'),
          totalCount => {
            totalCount.innerHTML = newSliderLength;
            return false;
          }
        );

        // Update slider current indexes as the ajaxed in slides will be incorrect
        Array.from(document.querySelectorAll('.swiper-slide')).map(
          (slide, i) => {
            const currentIndex = slide.querySelector('.js-current-slide-index');
            currentIndex.innerHTML = i + 1;

            return false;
          }
        );

        // Assign click handlers to dynamically added slides
        // TODO: check that already bound event listeners firing multiple are duped
        this.largerImageOption();
      }
    };

    xhr.send(`images=${imagesToLoad}`);
  }

  // Click handler attached to slider as tags can be dynamically added via ajax
  showTags() {
    const showTags = button => {
      const singleInfoContainer = button.parentNode.parentNode;
      button.classList.toggle('is-active');
      singleInfoContainer.classList.toggle('is-active-show-tags');
    };

    const handleClick = e => {
      if (e.target && e.target.classList.contains('js-show-tags-button')) {
        showTags(e.target);
      } else if (Utils.getClosest(e.target, '.js-show-tags-button')) {
        showTags(Utils.getClosest(e.target, '.js-show-tags-button'));
      }
    };

    Array.from(document.querySelectorAll('.c-slider')).map(slider => {
      slider.addEventListener('click', handleClick.bind(this));

      return false;
    });
  }
}

export default Slider;
